"use client";

import React from 'react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { useAuth } from '../../context/AuthContext';
import { useLocalizedPath } from '@/src/hooks/useLocalizedPath';
import styles from './Cart.module.css';

export const AccountPromoBanner: React.FC = () => {
  const t = useTranslations('cart');
  const { user } = useAuth();
  const { localizeFullPath } = useLocalizedPath();

  if (user) {
    return null;
  }

  return (
    <div className={styles.accountPromoBanner}>
      <span className={styles.accountPromoBannerIcon}>👤</span>
      <div className={styles.accountPromoBannerContent}>
        <p className={styles.accountPromoBannerTitle}>{t('accountPromo.title')}</p>
        <p className={styles.accountPromoBannerText}>
          {t.rich('accountPromo.body', { strong: (chunks) => <strong>{chunks}</strong> })}
        </p>
        <p className={styles.accountPromoBannerActions}>
          <Link href={localizeFullPath('/login')} className={styles.accountPromoBannerLink}>
            {t('accountPromo.cta')}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default AccountPromoBanner;
